export enum OrderType {
  Unknown,
  Cinelink,
  StreamingServer,
  MyHotelMovies,
  Adebs,
  All
}
